// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","link":"Button_link__Kr8EU"};